import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import LoadingScreen from './LoadingScreen';

function PrivateRoute({ children, userType }) {
    const location = useLocation();
    const { isAuthenticated, isLoading, userType: currentUserType, mustChangePassword } = useAuthStore();

    if (isLoading) {
        return <LoadingScreen />;
    }

    if (!isAuthenticated) {
        // Redirect to appropriate login page
        const loginPath = userType === 'admin' ? '/admin/login' : '/login';
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    // Check if user type matches
    if (userType && currentUserType !== userType) {
        return <Navigate to="/" replace />;
    }

    // Check if user must change password (only for regular users)
    if (
        userType === 'user' &&
        mustChangePassword &&
        location.pathname !== '/user/change-password'  // Fixed: changed from /dashboard/change-password
    ) {
        return <Navigate to="/user/change-password" replace />;  // Fixed: changed from /dashboard/change-password
    }

    return children;
}

export default PrivateRoute;